import { Button, Divider, TextField } from '@mui/material';
import { useState } from "react";
import { FormLead } from "./styles.js";
// import SearchBar from "../../components/search/index.jsx";

export default function Add() {
  // const [columns, setColumns] = useState([])
  const [fields, setFields] = useState(fieldsBase)
  const [search, setSearch] = useState('')

  const sendLead = () => {
    const url = "api/"
    if (fields.Tsource !== '' &&
      fields.Phone !== '' &&
      fields.Type !== '' &&
      fields.SubType !== '') {

    } else {
      console.log('err');
    }

  }

  const randomText = (length) => {
    const obj = {}

    const arr = fieldsNameB2C.filter((e) => {
      return e !== 'DateScheduled' && e !== 'TimeScheduled'
    })
    arr.map((e) => {
      let rand = (Math.random() + 1).toString(36).substring(length)
      if (/[0-9]/.test(rand)) {
        rand = rand.replace(/[0-9]+/g, 'a');
      }
      return obj[e] = rand
    });

    setFields(
      obj
    )
  }

  return (
    <FormLead>
      <h1>Add Lead</h1>
      <div className="content">
        <div className="buttons">
          <TextField
            size="small"
            margin="none"
            label={'Search'}
            variant="outlined"
            onChange={e => {
              setSearch(e.target.value)
            }} />
          <Button variant="contained" sx={{ backgroundColor: '#609' }} onClick={sendLead}>Send</Button>
          <Button variant="contained" onClick={() => randomText(2)}>Random</Button>
          <Button variant="contained" color="warning" onClick={() => setFields(fieldsBase)}>Clear all</Button>
        </div>

        <Divider sx={{ marginBottom: '1rem' }} />

        <div className="form">
          {fieldsNameB2C.map((e) => {
            return e.toLocaleLowerCase().includes(search.toLocaleLowerCase()) &&
              <TextField
                sx={{ width: '23.75%' }}
                margin="none"
                label={e}
                variant="outlined"
                key={e}
                value={fields[e]}
                onChange={ele => {
                  setFields({
                    ...fields,
                    [e]: ele.target.value
                  });
                  // console.log(fields);
                }} />
          })}
        </div>
      </div>
    </FormLead>
  );
}



const fieldsBase = {
  Type: "",
  SubType: "",
  Phone: "",
  Tsource: "",
  Lan: "pt",
  CountryCode: "",
  Name: "",
  Surname: "",
  Mail: "",
  Product: "",
  Offer: "",
  DateScheduled: "",
  TimeScheduled: "",
  Extra1: "",
  Extra2: "",
  Extra3: "",
  Extra4: "",
  Extra5: "",
  Extra6: "",
  Extra7: "",
  Extra8: "",
  Extra9: "",
  Extra10: "",
  Extra11: "",
  Extra12: "",
  Extra13: "",
  Extra14: "",
  Extra15: "",
  IpClient: "",
  Url: "",
  IdExt: "",
  cpf: "",
  rg: "",
  orgaoExpedidor: "",
  nomeMae: "",
  observacoes: "",
  sexo: "",
  dataNascimento: "",
  nomeEmpresa: "",
  segmento: "",
  gastoMensal: "",
  cnpj: "",
  mensagem: "",
  tecnologia: "",
  status: "",
  followUp: "",
  codPedido: "",
  dataPedido: "",
  horaPedido: "",
  pacoteTv: "",
  pacoteInternet: "",
  pacoteTelefone: "",
  itensAdicionais: "",
  termosCondicoes: "",
  Origem: "",
  campanha: "",
  dataAgendamentoEquipamento: "",
  periodoAgendamentoEquipamento: "",
  formaPagamento: "",
  dataVencimentoConta: "",
  pedido_anterior: "",
  Entrega: "",
  Numero: "",
  Cep: "",
  Bairro: "",
  Cidade: "",
  UF: "",
  Complemento: "",
  tipoImovel: "",
  dddTelefone2: "",
  numTelefone2: "",
  dddTelefone3: "",
  numTelefone3: "",
  telPreferencial: "",
  horarioPreferencial: "",
  optIn: "",
  source: "",
  media: "",
  content: "",
  canal: "",
  term: "",
  adn: "",
  utm_origem: "",
  id_session: "",
  nomeUsuario: "",
  dataFundacao: "",
  quantidadeSocios: "",
  quantidadeFiliais: "",
  quantidadeEnderecoReceita: "",
  cepMatriz: "",
  estadoFundacao: "",
  quantidadeLinhas: "",
  EntregaTipo: "",
  EntregaPontoReferencia: "",
  browserDevice: "",
  browser: "",
  browserOs: "",
  browserLan: "",
  geoIp: "",
  faturaDigital: "",
  numeroInscricaoEstadual: "",
  estadoInscricaoEstadual: "",
  gclid: "",
  tipoIp: "",
  enderecoCobranca: "",
  leadAmbiente: "",
  leadDevice: "",
  versaoTeste: "",
  pagEntrada: "",
  pagReferencia: "",
  ctaSaida: "",
  cidadeBussola: "",
  estadoBussola: "",
  idPID: "",
  fidelizado: "",
  pacoteMovel: "",
  pacoteCloud: "",
  banco: "",
  agencia: "",
  conta: "",
  UfOrgaoExpedidor: "",
  Portabilidade: "",
  NumPortabilidade: "",
  DataAgendamentoEquipamento2: "",
  DataAgendamentoEquipamento3: "",
  PeriodoAgendamentoEquipamento2: "",
  PeriodoAgendamentoEquipamento3: ""
}

const fieldsNameB2C =
  [
    "Tsource",
    "Type",
    "SubType",
    "Phone",
    "CountryCode",
    "Name",
    "Surname",
    "Mail",
    "Product",
    "Offer",
    "DateScheduled",
    "TimeScheduled",
    "Extra1",
    "Extra2",
    "Extra3",
    "Extra4",
    "Extra5",
    "Extra6",
    "Extra7",
    "Extra8",
    "Extra9",
    "Extra10",
    "Extra11",
    "Extra12",
    "Extra13",
    "Extra14",
    "Extra15",
    "IpUrl",
    "cpf",
    "rg",
    "orgaoExpedidor",
    "nomeMae",
    "observacoes",
    "sexo",
    "dataNascimento",
    "nomeEmpresa",
    "segmento",
    "gastoMensal",
    "cnpj",
    "mensagem",
    "tecnologia",
    "status",
    "followUp",
    "codPedido",
    "dataPedido",
    "horaPedido",
    "pacoteTv",
    "pacoteInternet",
    "pacoteTelefone",
    "itensAdicionais",
    "termosCondicoes",
    "Origem",
    "campanha",
    "dataAgendamentoEquipamento",
    "periodoAgendamentoEquipamento",
    "formaPagamento",
    "dataVencimentoConta",
    "pedido_anterior",
    "Entrega",
    "Numero",
    "Cep",
    "Bairro",
    "Cidade",
    "UF",
    "Complemento",
    "tipoImovel",
    "dddTelefone2",
    "numTelefone2",
    "dddTelefone3",
    "numTelefone3",
    "telPreferencial",
    "horarioPreferencial",
    "optIn",
    "source",
    "media",
    "content",
    "canal",
    "term",
    "adn",
    "utm_origem",
    "id_session",
    "IdExt",
    "nomeUsuario",
    "dataFundacao",
    "quantidadeSocios",
    "quantidadeFiliais",
    "quantidadeEnderecoReceita",
    "quantidadeLinhas",
    "EntregaTipo",
    "EntregaPontoReferencia",
    "browserDevice",
    "browser",
    "browserOs",
    "browserLan",
    "geoIp",
    "faturaDigital",
    "numeroInscricaoEstadual",
    "estadoInscricaoEstadual",
    "gclid",
    "tipoIp",
    "enderecoCobranca",
    "leadAmbiente",
    "leadDevice",
    "versaoTeste",
    "pagEntrada",
    "pagReferncia",
    "ctaSaida",
    "cidadeBussola",
    "estadoBussola",
    "idPID",
    "fidelizado",
    "pacoteMovel",
    "pacoteCloud",
    "banco",
    "agencia",
    "conta",
    "UfOrgaoExpedidor",
    "NumPortabilidade",
    "DataAgendamentoEquipamento2",
    "DataAgendamentoEquipamento3",
    "Portabilidade",
    "PeriodoAgendamentoEquipamento2",
    "PeriodoAgendamentoEquipamento3"
  ]
